import React from 'react';
import { Button, ButtonProps } from '@mui/material';
import { buttonBgColor } from '../utils/themeColor';

interface CustomButtonProps extends ButtonProps {
  children: React.ReactNode;
}

const CustomButton = ({ variant = 'contained', children, ...props }: CustomButtonProps) => {
  return (
    <Button
      variant={variant}
      sx={{
        backgroundColor: variant === 'contained' ? buttonBgColor : '',
        color: '#fff',
        py: 1,
        px: 3,
        borderRadius: '25px',
        fontWeight: 500,
        textTransform: 'capitalize',
        fontSize: { xs: '14px', sm: '12px' },
        lineHeight: '15px',
        border: `1px solid ${buttonBgColor}`,
        ...props.sx,
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

export default CustomButton;
